var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContactRequested = function SvgContactRequested(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.0335V17.3847C10.7318 17.0248 9.64206 16.9143 8.57233 17.0628C7.5026 17.2112 6.4841 17.6141 5.60236 18.2377C4.72062 18.8613 4.00139 19.6874 3.50506 20.6466C3.00873 21.6058 2.74979 22.67 2.75 23.75L0.5 23.7489C0.499651 22.3751 0.813786 21.0195 1.41834 19.7859C2.02289 18.5524 2.9018 17.4735 3.98774 16.6322C5.07368 15.7908 6.33782 15.2092 7.6833 14.9319C9.02877 14.6546 10.4199 14.6889 11.75 15.0324V15.0335ZM9.5 13.625C5.77062 13.625 2.75 10.6044 2.75 6.875C2.75 3.14562 5.77062 0.125 9.5 0.125C13.2294 0.125 16.25 3.14562 16.25 6.875C16.25 10.6044 13.2294 13.625 9.5 13.625ZM9.5 11.375C11.9863 11.375 14 9.36125 14 6.875C14 4.38875 11.9863 2.375 9.5 2.375C7.01375 2.375 5 4.38875 5 6.875C5 9.36125 7.01375 11.375 9.5 11.375ZM16.25 18.125V14.1875L21.875 19.25L16.25 24.3125V20.375H12.875V18.125H16.25Z",
    fill: "black",
    fillOpacity: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactRequested, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_requested.864a961f.svg";
export { ForwardRef as ReactComponent };